import React from 'react';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { Icon } from '@redturtle/iovisit-theme/components';
import { useWhishlist } from '@redturtle/iovisit-theme/helpers';
import { Label } from 'semantic-ui-react';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  wishlistStart: {
    id: 'Wishlist First Part',
    defaultMessage: 'Ci sono',
  },
  wishlistEnd: {
    id: 'Whishlist End Part',
    defaultMessage: 'elementi memorizzati nella tua wishlist',
  },
});

const HeaderWhishlist = ({ pathname }) => {
  const intl = useIntl();
  const { whishlist = [] } = useWhishlist();

  return (
    <div className="iv--header-whishlist">
      {__CLIENT__ && (
        <UniversalLink
          href={`/${intl.locale}/wishlist`}
          title={`${intl.formatMessage(messages.wishlistStart)} ${
            whishlist.length
          } ${intl.formatMessage(messages.wishlistEnd)}`}
        >
          {whishlist.length > 0 && <Label floating>{whishlist.length}</Label>}
          <Icon prefix={whishlist.length > 0 ? 'fas' : 'far'} icon="star" />
        </UniversalLink>
      )}
    </div>
  );
};

export default HeaderWhishlist;
